import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'
import uuid from 'uuid/v4'
import * as yup from 'yup'

export const commentSchema = yup.object().shape({
  id: yup.string()
    .notRequired(),
  message: yup.string()
    .notRequired(),
  type: yup.string().oneOf(['Archive Note', 'Note Comment'])
    .notRequired(),
  note_id: yup.string().notRequired(),
})

type BaseCommentType = {
  user_role_level: number
  user_role_name: string
  user_role_display_name: string
  user_role_id: string
  user_photo_url: string
  user_full_name: string
  user_id: string
  status: string
  created_date: string
  updated_date: string
}

export type CommentType = yup.InferType<typeof commentSchema>
export type CommentDeletedType = yup.InferType<typeof commentSchema> & BaseCommentType & {

}
export type CommentTypeWithStatus = CommentType & BaseCommentType & {
  deleted_comment?: CommentDeletedType | null
}

export function getEmptyComment(): CommentType {
  return {
    id: uuid(),
    note_id: '',
    message: '',
    type: 'Note Comment',
  }
}

export default function validator(data: CommentType) {
  return getValidationResult(data, commentSchema)
}
